/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TimeClockMoveForwardIcon16Light } from './TimeClockMoveForwardIcon16Light';
import { TimeClockMoveForwardIcon16Regular } from './TimeClockMoveForwardIcon16Regular';
import { TimeClockMoveForwardIcon16Solid } from './TimeClockMoveForwardIcon16Solid';
import { TimeClockMoveForwardIcon20Light } from './TimeClockMoveForwardIcon20Light';
import { TimeClockMoveForwardIcon20Regular } from './TimeClockMoveForwardIcon20Regular';
import { TimeClockMoveForwardIcon20Solid } from './TimeClockMoveForwardIcon20Solid';
import { TimeClockMoveForwardIcon24Regular } from './TimeClockMoveForwardIcon24Regular';
import { TimeClockMoveForwardIcon24Solid } from './TimeClockMoveForwardIcon24Solid';
import { TimeClockMoveForwardIcon32Regular } from './TimeClockMoveForwardIcon32Regular';
import { TimeClockMoveForwardIcon64Regular } from './TimeClockMoveForwardIcon64Regular';
var sizes = {
    16: {
        light: TimeClockMoveForwardIcon16Light,
        regular: TimeClockMoveForwardIcon16Regular,
        solid: TimeClockMoveForwardIcon16Solid,
    },
    20: {
        light: TimeClockMoveForwardIcon20Light,
        regular: TimeClockMoveForwardIcon20Regular,
        solid: TimeClockMoveForwardIcon20Solid,
    },
    24: {
        regular: TimeClockMoveForwardIcon24Regular,
        solid: TimeClockMoveForwardIcon24Solid,
    },
    32: {
        regular: TimeClockMoveForwardIcon32Regular,
    },
    64: {
        regular: TimeClockMoveForwardIcon64Regular,
    },
};
export var TimeClockMoveForwardIcon = forwardRef('TimeClockMoveForwardIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
